<div class="flex flex-col items-center p-4 m-4">
  <p class="text-6xl font-extrabold mb-10">{{name}}</p>
  <div class="flex flex-col md:flex-row md:justify-between bg-gray-100 p-10 rounded">
    <img [src]="img" class="h-96 w-96 mr-40">
    <div *ngIf="info" class="flex flex-col h-96 overflow-scroll no-scrollbar">
      <div *ngFor="let item of info" class="mb-2">
        <iframe class="" [src]="item.uri | domsafe:'https://open.spotify.com/embed?uri='" height="80" width="300"
          frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>
      </div>
    </div>

  </div>

</div>